import { render, staticRenderFns } from "./DocumentUsersSelector.vue?vue&type=template&id=5a91766a&scoped=true&"
import script from "./DocumentUsersSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentUsersSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentUsersSelector.vue?vue&type=style&index=0&id=5a91766a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91766a",
  null
  
)

export default component.exports